"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFocusRef = void 0;
var react_1 = require("react");
var useFocusRef = function (focus) {
  var ref = (0, react_1.useRef)();
  (0, react_1.useEffect)(function () {
    // @ts-ignore
    if (focus && ref && ref.current && ref.current.focus) {
      // @ts-ignore
      ref.current.focus();
      // @ts-ignore
      // ref.current.select();
    }
  }, []);
  return ref;
};
exports.useFocusRef = useFocusRef;